import { CalendarOrders } from './calendar-orders.interface';

export const CALENDAR_ORDERS_INITIAL_STATE: CalendarOrders = {
  data: {
    dates: [],
    legend: [],
  },
  loading: false,
  loaded: false,
  deliveryDaysRequesting: false,
  deliveryDaysRequested: false,
  selectedTemplate: null,
  availableDays: null,
  UI: {
    startDate: null,
    endDate: null,
  },
};
